//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0]],[]];
SPLM.MeshProfileString = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MeshProfileString";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MeshProfileString.Type = Object.freeze({
    "Profile" : "Profile", "Guide" : "Guide", "Orient" : "Orient", "Scale" : "Scale", "Spine" : "Spine"});

SPLM.MeshProfileString.SelectedPoint = Object.freeze({
    "None" : "None", "First" : "First", "Last" : "Last", "Both" : "Both"});

SPLM.MeshProfileString.InsertOrder = Object.freeze({
    "After" : "After", "Before" : "Before"});

export default SPLM;